import { FC } from 'react';

const Page404: FC = () => {
  return (
    <>
      <h1>Page: Page404</h1>
    </>
  );
};

export default Page404;
